import { administrationRequests } from "api/administrationApi";
import React from "react";
import { ReferenceInput, SelectInput } from "react-admin";

const InstructionLanguagesInput = ({ source, alwaysOn = false, readOnly = false, fullWidth = false }) => {
  return (
    <ReferenceInput
      source="instructionLanguageId"
      alwaysOn={alwaysOn}
      reference={administrationRequests.getInstructionLanguagesSelect()}
      label="Език на обучение"
    >
      <SelectInput
        optionText="name"
        label="Език на обучение"
        required
        fullWidth
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default InstructionLanguagesInput;
